/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "react-i18next";
import { Price } from "./__simple/_price";
import { useContext } from "react";
import ConfirmContext from "../utils/confirmContext";
import { useUserCart } from "../User/hooks/useUserCart";
import { LikeButton } from "./__simple/_likeButton";
import { useUserFavorite } from "../User/hooks/useUserFavorite";
import config from "../configuration/config";
import * as tracking from "../services/trackingCarEvents";


function Car({
  year,
  slug,
  colorID,
  type,
  id,
  qty,
  img,
  name = "",
  category,
  brand,
  group,
  brandID,
  brandIcon,
  brandImage,
  gifts = 0,
  miniDownPayment,
  colorName = "",
  minPrice,
  link,
  showDetails = true,
  hybird = false,
  newCar = false,
  ProductId,
  Tax = 0,
  RateCareDiscount = 0,
  modelTypes,
  sharable = true,
  hybridImage,
  discountPrice,
  isOnline = false,
  showPric = false,
  buyOnline = false,
  goBuyDerict = false,
  carData = {},
  onClickShowSN,
  btnShowSN = false,
  className = "",
  listcolors = [],
}) {


  const { t: trans, i18n } = useTranslation(["common", "info", "vehicales", "compare", "car"]);
  const context = useContext(ConfirmContext);
  let lang = i18n.language || "ar";
  const languageDir = "language-" + lang;
  const { isFavoriteItem, changeFavoriteItemState } = useUserFavorite();
  const { cartItems, changecartItem } = useUserCart();
  const isInCart = cartItems?.some(item => String(item.ProductID) === String(ProductId));

  const handleApply = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      if (goBuyDerict === true) {
        var obb = {
          id: id,
          Type: "car",
          colorId: colorID,
          name: carData?.descriptionAr,
          nameEn: carData?.descriptionEn,
          price: minPrice,
          brand: carData?.brandAr,
          brandEn: carData?.brandEn,
          Tax: Tax,
          image: img,
          Discount: RateCareDiscount,
          productID: ProductId,
          group: carData?.groupAr,
          groupEn: carData?.groupEn,
          BrandID: brandID,
          modelTypes: carData?.descriptionAr,
          modelTypesEn: carData?.descriptionEn,
          colorName: carData?.colorNameAr,
          colorNameEn: carData?.colorNameEn,
          SN: carData?.sn,
          year: year,
          modelTypeID: type,
          MiniDownPayment: miniDownPayment,
        };
        changecartItem(ProductId, colorID, type, 1, null, null, obb, null, year);
      } else {
        context.onShow({
          modelYear: year,
          displayConfirm: true,
          title: name,
          image: img,
          backGround: brandImage,
          brand: brand,
          brandID: brandID,
          isHyper: hybird,
          isNew: newCar,
          defaultColorID: colorID,
          cartDetails: {
            id: ProductId,
            name: name,
            price: minPrice,
            brand: brand,
            image: img,
            Tax: Tax,
            Discount: RateCareDiscount,
            Type: "car",
            modelTypes: modelTypes,
          },
          carOrder: {
            vehicle: ProductId,
            group: group,
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };



  return (
    <div className={`vc ${className} ${languageDir} dark:bg-[#1a1c23] dark:border-white/10`} onClick={(e) => {
      if (!e.target.closest('button') && !e.target.closest('input')) {
        tracking.trackSelectCar(carData, "vehicles_list", "Vehicles List");
        window.location.href = link;
      }
    }}
      style={{
        background: 'var(--surface, #fff)',
        cursor: 'pointer',
        borderRadius: '18px',
        overflow: 'hidden',
        border: '1px solid rgba(0,0,0,.04)',
        transition: 'all .35s cubic-bezier(.4,0,.2,1)',
        position: 'relative'
      }}
    >
      <div className="vc-img dark:bg-[#000]" style={{ position: 'relative', overflow: 'hidden', background: '#f5f5f5' }}>

        {newCar && <span className="vc-type" style={{ position: 'absolute', top: '10px', left: lang === 'ar' ? 'auto' : '10px', right: lang === 'ar' ? '10px' : 'auto', zIndex: 2, padding: '5px 12px', borderRadius: '6px', background: 'rgba(24,169,78,.85)', color: '#fff', fontSize: '10.5px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>{trans("info:new")}</span>}
        {(hybird && !newCar) && <span className="vc-type" style={{ position: 'absolute', top: '10px', left: lang === 'ar' ? 'auto' : '10px', right: lang === 'ar' ? '10px' : 'auto', zIndex: 2, padding: '5px 12px', borderRadius: '6px', background: 'rgba(24,169,78,.85)', color: '#fff', fontSize: '10.5px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>{trans("vehicales:veh-hybrid")}</span>}

        {isInCart && (
          <div className="vc-incart-badge" style={{ position: 'absolute', top: '12px', left: '50%', transform: 'translateX(-50%)', zIndex: 3, background: 'rgba(24, 169, 78, 0.95)', color: '#fff', padding: '4px 12px', borderRadius: '100px', fontSize: '10px', fontWeight: 800, display: 'flex', alignItems: 'center', gap: '5px', boxShadow: '0 4px 12px rgba(24, 169, 78, 0.3)', backdropFilter: 'blur(4px)', animation: 'slide-down-badge 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)' }}>
            <svg viewBox="0 0 24 24" style={{ width: '12px', height: '12px', fill: 'none', stroke: 'currentColor', strokeWidth: 3 }}><polyline points="20 6 9 17 4 12"></polyline></svg>
            {trans("info:added_to_cart") || (lang === 'ar' ? 'في السلة' : 'IN CART')}
          </div>
        )}

        <button className="vc-fav dark:bg-black/50" style={{ position: 'absolute', top: '10px', left: lang === 'ar' ? '10px' : 'auto', right: lang === 'en' ? '10px' : 'auto', zIndex: 2, width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(255,255,255,.9)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', transition: 'all .2s' }} onClick={(e) => { e.stopPropagation(); changeFavoriteItemState(ProductId); }}>
          <LikeButton favorite={Boolean(isFavoriteItem(ProductId))} onToggle={() => { }} className="dark:invert" />
        </button>

        {buyOnline && (
          <div className="vc-viewers" style={{ position: 'absolute', bottom: '10px', right: lang === 'ar' ? '10px' : 'auto', left: lang === 'en' ? '10px' : 'auto', zIndex: 2, display: 'flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '6px', background: 'rgba(0,0,0,.65)', backdropFilter: 'blur(6px)', fontSize: '10px', color: '#fff', fontWeight: 600 }}>
            <span className="pdot" style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#18a94e', animation: 'pulse-dot 1.5s infinite' }}></span>
            {trans("info:Available_for_purchase_online")}
          </div>
        )}

        {btnShowSN && (
          <div
            style={{ position: 'absolute', bottom: '10px', left: lang === 'ar' ? '10px' : 'auto', right: lang === 'en' ? '10px' : 'auto', zIndex: 2, width: '38px', height: '38px', background: 'rgba(0,0,0,.65)', backdropFilter: 'blur(6px)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all .2s' }}
            className="vc-cam-btn"
            onClick={(e) => {
              e.stopPropagation();
              if (onClickShowSN) onClickShowSN(carData?.sn);
            }}
            title={trans("info:Preview")}
          >
            <img src="/assets/icons/camera-svgrepo-com.svg" style={{ width: '18px', height: '18px', filter: 'invert(1) brightness(2)' }} alt="camera" />
          </div>
        )}

        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
          <img src={config.mainURL + img} alt={name} style={{ width: '100%', height: '100%', objectFit: 'contain', transition: 'transform .5s cubic-bezier(.4,0,.2,1)' }} />
        </div>
      </div>

      <div className="vc-body" style={{ padding: '20px' }}>
        <div className="vc-name dark:text-white" style={{ fontSize: '16.5px', fontWeight: 800, marginBottom: '4px', color: '#111' }}>
          <a style={{ fontSize: '16.5px', color: brandID === 1 ? '#e60012' : '#585858ff' }}>{name}</a>
        </div>
        <div className="vc-sub dark:text-[#8a8f99]" style={{ fontSize: '13px', color: '#777', marginBottom: '14px', fontWeight: 500 }}>
          {group} {colorName ? `· ${colorName.split('/')[0]}` : ''}
        </div>

        <div className="vc-specs" style={{ display: 'flex', gap: '14px', marginBottom: '16px', flexWrap: 'wrap' }}>
          {/* <span className="vc-spec dark:text-[#8a8f99]" style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#777', fontWeight: 600 }}>
            <svg viewBox="0 0 24 24" style={{ width: '15px', height: '15px', stroke: 'currentColor', fill: 'none', strokeWidth: 2 }}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
            {year}
          </span> */}
          {gifts > 0 && (
            <span className="vc-spec dark:text-[#8a8f99]" style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#777', fontWeight: 600 }}>
              <img src="/assets/icons/gift.svg" alt="gift" style={{ width: '15px', height: '15px', opacity: 0.7 }} className="dark:invert dark:brightness-0" />
              {gifts} {trans("gifts")}
            </span>
          )}
        </div>

        <div className="vc-foot dark:border-white/10" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '16px', paddingTop: '16px', borderTop: '1px solid rgba(0,0,0,.04)' }}>
          <div className="vc-price" style={{ fontSize: '19px', fontWeight: 800, color: '#23cc4f', fontFamily: '"Playfair Display", Georgia, serif' }}>
            {(showPric || goBuyDerict) ? (
              <div>
                <Price price={minPrice} style={{ color: '#23cc4f' }} />
                {discountPrice > 0 && <span style={{ fontSize: '13px', color: '#ef4444', textDecoration: 'line-through', marginLeft: '8px' }}><Price price={discountPrice} /></span>}
                <small className="dark:text-[#8a8f99]" style={{ fontSize: '11.5px', fontWeight: 600, color: '#777', display: 'block', marginTop: '3px' }}> · {trans("new:price_inclusive_note") || "Price includes VAT"}</small>
              </div>
            ) : (
              <span className="dark:text-[#8a8f99]" style={{ fontSize: '14px', fontWeight: 700, color: '#777' }}>{trans("info:contact_for_price") || "Contact for Price"}</span>
            )}
          </div>
          {(showPric || goBuyDerict) && (
            <button className="vc-go group/btn hover:scale-110" style={{ background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', transition: 'all .2s', padding: 0 }} onClick={(e) => handleApply(e)}>
              {isInCart ? (
                <div style={{ position: 'relative', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/assets/icons/cart.svg" alt="in cart" className="w-[28px] h-[28px] opacity-20" style={{ filter: "brightness(0) saturate(100%) invert(48%) sepia(85%) saturate(3015%) hue-rotate(119deg) brightness(97%) contrast(92%)" }} />
                  <div style={{ position: 'absolute', width: '20px', height: '20px', background: '#18a94e', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 5px rgba(24, 169, 78, 0.4)' }}>
                    <svg viewBox="0 0 24 24" style={{ width: '12px', height: '12px', fill: 'none', stroke: '#fff', strokeWidth: 4 }}><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>
              ) : (
                <img src="/assets/icons/cart.svg" alt="buy" className="w-[28px] h-[28px] transition-all duration-200" style={{ filter: "brightness(0) saturate(100%) invert(48%) sepia(85%) saturate(3015%) hue-rotate(119deg) brightness(97%) contrast(92%)" }} />
              )}
            </button>
          )}
        </div>

        {/* Colors line */}
        {listcolors?.length > 0 && (
          <div className="dark:border-white/10" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid rgba(0,0,0,.04)' }}>
            {listcolors.slice(0, 5).map((color, index) => (
              <div key={index} style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.1)' }} title={color?.name}>
                <img src={config.FilePathURL + color?.image} alt={color?.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            ))}
            {listcolors.length > 5 && <span className="dark:text-[#8a8f99]" style={{ fontSize: '11px', color: '#777', fontWeight: 800 }}>+{listcolors.length - 5}</span>}
          </div>
        )}
      </div>
      <style>{`
        .vc { height: 100%; display: flex; flex-direction: column; box-shadow: 0 4px 12px rgba(0,0,0,0.03); }
        .vc-img { height: 210px; flex-shrink: 0; }
        .vc-body { flex: 1; display: flex; flex-direction: column; }
        .vc-foot { margin-top: auto; }
        .vc:hover { transform: translateY(-5px); box-shadow: 0 14px 40px rgba(0,0,0,.08); border-color: rgba(0,0,0,0.1) !important; }
        .vc:hover .vc-img img { transform: scale(1.08) !important; }
        .vc-fav:hover { transform: scale(1.1); background: #fff !important; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }
        .vc-cam-btn:hover { background: #18a94e !important; }
        .dark .vc-fav img { filter: brightness(0) invert(1) !important; }
        .dark .vc-img { background: #111 !important; }
        
        @media (max-width: 768px) {
          .vc-img { height: 160px; }
          .vc-body { padding: 15px !important; }
          .vc-name { fontSize: 15px !important; }
          .vc-name a { fontSize: 15px !important; }
          .vc-sub { fontSize: 12px !important; margin-bottom: 10px !important; }
          .vc-price { fontSize: 17px !important; }
          .vc-foot { gap: 12px !important; paddingTop: 12px !important; }
        }

        @keyframes pulse-dot { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: .4; transform: scale(1.4); } }
        @keyframes slide-down-badge {
          0% { opacity: 0; transform: translateX(-50%) translateY(-20px) scale(0.8); }
          100% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}

export default Car;
